const ALLOWED_TYPES = new Set([
    "Page","Column","Row","Section","Container","Grid","Stack",
    "Text","Image","Button","Card","NavigationBar","Footer",
    "Divider","Form","EmailSubscriptionForm","Video"
  ]);
  
  const LEAF_TYPES = new Set(["Text", "Image", "Button", "Divider", "Video"]);
  
  export function stripTreeNode(node) {
    return {
      id: String(node.id),
      type: String(node.type),
      ...(Array.isArray(node.children) ? { children: node.children.map(stripTreeNode) } : {}),
    };
  }
  
  export function validateTree(nodes) {
    const walk = (n) => {
      if (!n?.id || !n?.type) throw new Error("Tree invalid: missing id/type");
      if (!ALLOWED_TYPES.has(n.type)) throw new Error(`Tree invalid: illegal type ${n.type}`);
      if (LEAF_TYPES.has(n.type) && Array.isArray(n.children) && n.children.length) {
        throw new Error(`Tree invalid: ${n.type} cannot have children`);
      }
      if (Array.isArray(n.children)) n.children.forEach(walk);
    };
    (nodes || []).forEach(walk);
  }
  
  export function cloneTree(tree) {
    return JSON.parse(JSON.stringify(tree || []));
  }
  
  export function findNodeWithParent(tree, targetId, parent = null) {
    for (const n of tree) {
      if (String(n.id) === String(targetId)) return { node: n, parent };
      if (Array.isArray(n.children)) {
        const found = findNodeWithParent(n.children, targetId, n);
        if (found) return found;
      }
    }
    return null;
  }
  
  export function removeNodeById(tree, targetId) {
    const id = String(targetId);
    const walk = (arr) => {
      if (!Array.isArray(arr)) return false;
      const idx = arr.findIndex((x) => String(x.id) === id);
      if (idx !== -1) {
        arr.splice(idx, 1);
        return true;
      }
      for (const n of arr) {
        if (walk(n.children)) return true;
      }
      return false;
    };
    walk(tree);
    return tree;
  }
  
  export function insertNode(tree, parentId, index, node) {
    const found = findNodeWithParent(tree, parentId);
    if (!found?.node) throw new Error(`insertNode: parentId not found "${parentId}"`);
    found.node.children = Array.isArray(found.node.children) ? found.node.children : [];
    const i = typeof index === "number" ? index : found.node.children.length;
    found.node.children.splice(Math.max(0, i), 0, node);
    return tree;
  }
  
  export function moveNode(tree, id, newParentId, newIndex) {
    const found = findNodeWithParent(tree, id);
    if (!found?.node) throw new Error(`moveNode: id not found "${id}"`);
    const node = found.node;
  
    // remove first
    removeNodeById(tree, id);
  
    // insert into new parent
    insertNode(tree, newParentId, newIndex, node);
    return tree;
  }